import React from 'react';
import { Sec, SH } from '../components/Section';
import { Btn, Crd } from '../components/Button';
import { MockupGraphic } from '../components/MockupGraphic';
import { C } from '../constants';
import { useTheme } from '../contexts/ThemeContext';
import { motion } from 'framer-motion';

export const SlidrWidget = () => {
  const { theme } = useTheme();

  // Exact original content - service pillars
  const pillars = ['Strategy', 'Narrative', 'Design', 'Delivery'];

  return (
    <Sec id="slidr-widget" dark={theme === 'light'}>
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <SH
          eyebrow="DONE FOR YOU"
          title="Need Us to Build Your Deck?"
          center
        />

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{ marginTop: '48px' }}
        >
          <Crd glow data-testid="slidr-info-card" style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
            <h3 style={{ 
              fontSize: '40px', 
              fontWeight: 700, 
              marginBottom: '24px', 
              fontFamily: "'Sansation', sans-serif",
              background: C.grad,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
              Slidr
            </h3>
            
            <p className="font-[Manrope]" style={{ fontSize: '18px', lineHeight: 1.6, opacity: 0.85, marginBottom: '32px' }}>
              Strategy. Narrative. Design. Delivery. We build the deck. You close the deal.
            </p>

            {/* Service Pillars */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '32px', 
              flexWrap: 'wrap',
              marginBottom: '32px'
            }}>
              {pillars.map((pillar, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.1 }}
                  viewport={{ once: true }}
                  style={{
                    padding: '16px 24px',
                    background: 'rgba(255,255,255,0.05)',
                    borderRadius: '12px',
                    border: `1px solid ${C.secondary}30`
                  }}
                >
                  <span style={{ fontSize: '14px', fontWeight: 700, letterSpacing: '0.1em', color: C.secondary }}>
                    {pillar}
                  </span>
                </motion.div>
              ))}
            </div>

            {/* Starting Price */}
            <div style={{ marginBottom: '32px' }}>
              <div style={{ fontSize: '14px', opacity: 0.6, marginBottom: '8px' }}>Starting at</div>
              <span style={{ fontSize: '48px', fontWeight: 700, fontFamily: "'Sansation', sans-serif" }}>$779</span>
            </div>

            <Btn variant="primary" to="/slidr" large>
              Inquire About Slidr
            </Btn>
          </Crd>
        </motion.div>

        {/* Optional Mockup */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{ marginTop: '48px' }}
        >
          <MockupGraphic type="artefacts" label="Slidr Deck Preview" />
        </motion.div>
      </div>
    </Sec>
  );
};
